import CalledsTable from '../components/calledsTable/calledsTable.vue'

export default {
  components: {
    CalledsTable,
  },

  data: () => ({}),

  methods: {},

  created() {},
}
